import { render, staticRenderFns } from "./PromotionSlider.vue?vue&type=template&id=af49d44a&"
import script from "./PromotionSlider.vue?vue&type=script&lang=js&"
export * from "./PromotionSlider.vue?vue&type=script&lang=js&"
import style0 from "./PromotionSlider.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af49d44a')) {
      api.createRecord('af49d44a', component.options)
    } else {
      api.reload('af49d44a', component.options)
    }
    module.hot.accept("./PromotionSlider.vue?vue&type=template&id=af49d44a&", function () {
      api.rerender('af49d44a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/betsur/modules/components/pages/parts/itemSets/PromotionSlider.vue"
export default component.exports